<template>
  <footer class="footer" id="#contacts">
    <div class="container">
      <div class="row">
        <div class="col-24 col-md-8 col-lg-6">
          <a :href="'tel:' + footerPhone[0]" class="d-none d-md-inline-block footer-phone">{{ footerPhone[0] }}</a>
          <ul class="footer-menu">
            <li class="footer-menu__item" v-for="item of footerMenuColumnFirst" :key="item.id">
              <a class="footer-menu__url" :href="item.url" target="_blank">{{ item.title }}</a>
            </li>
            <li class="footer-menu__item">
              <a
                class="footer-menu__url"
                size="medium"
                type="inline"
                @click.prevent="toggleCallBackFormModal(true)"
                href="#"
              >
                {{ t[locale]['tehnobank.footer.call_button'] }}
              </a>
            </li>
          </ul>
        </div>
        <div class="col-24 col-md-10 col-lg-7">
          <a :href="'mailto:' + footerEmail" class="d-none d-md-inline-block footer-email">{{ footerEmail }}</a>
          <ul class="footer-menu">
            <li class="footer-menu__item" v-for="item of footerMenuColumnSecond" :key="item.id">
              <a class="footer-menu__url" :href="item.url" target="_blank"> {{ item.title }}</a>
            </li>
            <li class="footer-menu__item">
              <a
                class="footer-menu__url"
                href="/pdf/rules_for_the_promotion.pdf"
                target="_blank"
              >
                {{ t[locale]['tehnobank.footer.promotion_rules'] }}
              </a>
            </li>
          </ul>
        </div>
        <div class="col-24 col-md-6 col-lg-11">
          <div class="d-md-none">
            <a :href="'tel:' + footerPhone[0]" class="footer-phone">{{ footerPhone[0] }}</a>
          </div>
          <div class="d-md-none">
            <a :href="'mailto:' + footerEmail" class="footer-email">{{ footerEmail }}</a>
          </div>
          <div class="d-flex flex-column">
            <a href="https://tb.by/individuals/" class="footer-site" target="_blank" rel="noopener noreferrer">tb.by</a>
          </div>
          <div
            class="d-flex align-items-center justify-content-between justify-content-lg-end mb-4 mb-lg-0 mt-4 footer-logos"
          >
            <img :src="require('@javascript/packs/images/@tehnobank/footer-image-pci-dss.png')" alt="PCI-DSS" />
            <img
              class="d-md-none d-lg-block ml-lg-5"
              :src="require('@javascript/packs/images/@tehnobank/footer-image-kocmoc.png')"
              alt="КОСМОС"
            />
          </div>
        </div>
      </div>
      <vl-information-static-block class="mt-3 mb-3" :text="renderUserTokenAndTextCallCenter" />

      <div class="footer-copyright" v-html="copyrightText"></div>
    </div>

    <vl-modal
      :open="visibleCallBackForm"
      @close="toggleCallBackFormModal(false)"
      title-transform="none"
      max-width="580"
      static-scroll
    >
      <template #header>
        {{ t[locale]['modals.call_back.title_part1'] }}
        <br />
        {{ t[locale]['modals.call_back.title_part2'] }}
      </template>
      <template #default>
        <call-back-form :locale="locale" @closeModall="toggleCallBackFormModal(false)" />
      </template>
    </vl-modal>
  </footer>
</template>

<script>
import VlModal from '@components/@tehnobank/ui/vl-modal'
import VlInformationStaticBlock from '@components/@tehnobank/ui/vl-information-static-block'
import CallBackForm from './call-back-form/CallBackForm'
import locales from './locales'
export default {
  name: 'Footer',
  components: {
    CallBackForm,
    VlModal,
    VlInformationStaticBlock,
  },
  props: {
    footerMenu: {
      type: String,
      default: null,
    },
    footerCopyright: {
      type: String,
      default: null,
    },
    footerPhone: {
      type: Array,
      default: [],
    },
    footerEmail: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      default: '',
    },
    userToken: {
      type: String,
      require: true,
    },
  },
  data: () => ({
    visibleCallBackForm: false,
    t: locales,
  }),
  computed: {
    renderCurrentYear() {
      return new Date().getFullYear()
    },
    footerMenuColumnFirst() {
      if (this.footerMenu) {
        let normalizedData = JSON.parse(this.footerMenu)
        return normalizedData.children[0].children
      }
    },
    footerMenuColumnSecond() {
      if (this.footerMenu) {
        let normalizedData = JSON.parse(this.footerMenu)
        return normalizedData.children[1].children
      }
    },
    renderUserTokenAndTextCallCenter() {
      return `${this.t[locale]['tehnobank.footer.information_about_callcenter']} ${this.userToken}`
    },
    copyrightText() {
      return `&copy; ${this.renderCurrentYear} ${this.t[locale]['tehnobank.copyright']}`
    }
  },
  methods: {
    toggleCallBackFormModal(value) {
      this.visibleCallBackForm = value
    },
  },
}
</script>
